import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILoadingOverlayState } from "../interfaces/ILoadingOverlayState";

export const loadingOverlaySlice = createSlice({
  name: 'language',
  initialState: {
    isVisible: false,
    message: undefined,
  } as ILoadingOverlayState,
  reducers: {
    showLoadingOverlay: (state: ILoadingOverlayState, action: PayloadAction<string>): void => {
      state.isVisible = true;
      state.message = action.payload;
    },
    hideLoadingOverlay: (state: ILoadingOverlayState): void => {
      state.isVisible = false;
      state.message = undefined;
    },
  },
});

export const { showLoadingOverlay,  hideLoadingOverlay } = loadingOverlaySlice.actions
export default loadingOverlaySlice.reducer